import { flow, pipe } from 'fp-ts/function';
import {
  authHeaders,
  createAuthorizedGetRequest,
  createPostRequest,
  decode,
  decodeVersioned,
  fetchApi, formMultipartHeaders, setBodyFormData, setQuery,
} from '@/services/api';
import { chain, map } from 'fp-ts/TaskEither';
import { TemplateDetail, TemplateList } from '@/services/api/resources/template/codec';
import { encodeTemplateQuery, TemplateSearchQuery } from '@/services/api/resources/template/query';

const baseUrl = '/v2/templates';
const recordUrl = (id: number): string => `${baseUrl}/${id}`;

export const list = (query: TemplateSearchQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodeTemplateQuery(query))),
  chain(fetchApi),
  chain(decode(TemplateList)),
);

export const get = flow(
  recordUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decodeVersioned(TemplateDetail)),
);

/** @deprecated This is only to be used while we don't refactor the checklists */
export const createChecklistFromTemplate = (bodyForm: FormData) => pipe(
  '/nova-api/checklists',
  authHeaders(formMultipartHeaders(createPostRequest)),
  map(setBodyFormData(bodyForm)),
  chain(fetchApi),
);
